var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0625 1.02295H10.3125M6.0625 2.6167H8.71875M6.0625 6.33545H10.3125M6.0625 7.9292H8.71875M2.34375 8.46045H2.875C3.4618 8.46045 3.9375 7.98475 3.9375 7.39795V6.8667C3.9375 6.2799 3.4618 5.8042 2.875 5.8042H2.34375C1.75695 5.8042 1.28125 6.2799 1.28125 6.8667V7.39795C1.28125 7.98475 1.75695 8.46045 2.34375 8.46045ZM2.34375 3.14795H2.875C3.4618 3.14795 3.9375 2.67225 3.9375 2.08545V1.5542C3.9375 0.967397 3.4618 0.491699 2.875 0.491699H2.34375C1.75695 0.491699 1.28125 0.967397 1.28125 1.5542V2.08545C1.28125 2.67225 1.75695 3.14795 2.34375 3.14795Z",
    stroke: "#FF7926",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.d02fd088fa5fc298172f4c30e39485ce.svg";
export { ForwardRef as ReactComponent };